import store from ".";
import { APPLICATION_MODULE, QUESTIONS_MODULE } from "./types/module-types";

export class QuestionStore {
  static state(stateName) {
    return store.state[QUESTIONS_MODULE][stateName];
  }
  static getters(getterName) {
    return store.getters[`${QUESTIONS_MODULE}/${getterName}`];
  }
  static dispatch(actionName, params) {
    return store.dispatch(`${QUESTIONS_MODULE}/${actionName}`, params, {
      root: true,
    });
  }
}

export class ApplicationStore {
  static state(stateName) {
    return store.state[APPLICATION_MODULE][stateName];
  }
  static getters(getterName) {
    return store.getters[`${APPLICATION_MODULE}/${getterName}`];
  }
  static dispatch(actionName, params) {
    return store.dispatch(`${APPLICATION_MODULE}/${actionName}`, params, {
      root: true,
    });
  }
}
